import React from "react";
import { SmartObject } from "../../../types";
import { SmartObjectSvgRenderer } from "./Svg";

interface SmartObjectRendererProps {
  smartObject: SmartObject;
  extraStyles?: React.CSSProperties;
}

function SmartObjectRendererImpl(props: Readonly<SmartObjectRendererProps>) {
  const { smartObject, extraStyles } = props;
  const { elementList, objectId } = smartObject;

  return (
    <>
      {elementList.map((element, index) => {
        const { type } = element;
        if (type === "svg") {
          return (
            <SmartObjectSvgRenderer
              key={`${objectId}-${index}`}
              element={element}
              objectId={objectId}
              extraStyles={extraStyles}
            />
          );
        }
      })}
    </>
  );
}

export const SmartObjectRenderer = React.memo(SmartObjectRendererImpl);
